export default {"src":"/_next/static/media/Electronics.edf5290a.svg","height":75,"width":76};